import {lazy} from '@aboutyou/lazy-imports';

export const DevTools = lazy(() =>
  import('./DevTools.eager').then(mod => ({default: mod.DevTools})),
);
